module.exports = __webpack_public_path__ + "static/media/login-badge.6a330be8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-badge.svg
// module id = 446
// module chunks = 0